// Global fetch interceptor - automatically adds session token to ALL API calls
// Uses MULTIPLE methods to ensure token reaches backend even through proxies

const originalFetch = window.fetch.bind(window);

let sessionExpiredHandled = false;

window.fetch = function(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : (input as Request).url;
  
  if (url.includes('/api/')) {
    const token = localStorage.getItem('session_token');
    if (token) {
      init = init || {};
      
      let headers: Record<string, string> = {};
      
      if (init.headers instanceof Headers) {
        init.headers.forEach((value, key) => { headers[key] = value; });
      } else if (init.headers && typeof init.headers === 'object') {
        headers = { ...(init.headers as Record<string, string>) };
      }
      
      // Send token via MULTIPLE headers for proxy resilience
      if (!headers['Authorization'] && !headers['authorization']) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      // Custom header - proxies never strip X- headers
      if (!headers['X-Session-Token']) {
        headers['X-Session-Token'] = token;
      }
      
      init.headers = headers;
    }
    
    return originalFetch(input, init).then(response => {
      if (response.status === 401 && url.includes('/api/') && !url.includes('/api/auth/')) {
        const hasToken = localStorage.getItem('session_token');
        if (hasToken && !sessionExpiredHandled) {
          sessionExpiredHandled = true;
          localStorage.removeItem('session_token');
          localStorage.removeItem('ram_naam_user_cache');
          localStorage.removeItem('ram_naam_session_user');
          setTimeout(() => { sessionExpiredHandled = false; }, 5000);
        }
      }
      return response;
    });
  }
  
  return originalFetch(input, init);
};

export {};
